/**
 * Store for `DATA.views`
 * @module
 */

var _ = require('optimizely-client-fn');
var actionTypes = require('../constants/action_types');
var freeze = require('../utils/freeze');

/**
 * Holds the data for every view
 */
module.exports = {
  initialize: function() {
    this.__state = {
      views: {},
      apiNamesToViews: {},
    };
    this.on(actionTypes.DATA_LOADED, this.__loadData);
  },

  /**
   * Retrieve all view data
   * @returns {View[]}
   */
  getAll: function(): View[] {
    return freeze.safeReference(_.values(this.__state.views));
  },

  getPagesMap: function() {
    return freeze.safeReference(this.__state.views);
  },

  /**
   * Retrieve a single view
   * @param {number} id
   * @returns {View} View with the specified id
   */
  get: function(id:number): View {
    return freeze.safeReference(this.__state.views[id]);
  },

  /**
   * @param {string} apiName
   * @return {View}
   */
  getByApiName: function(apiName:string): View {
    return freeze.safeReference(this.__state.apiNamesToViews[apiName]);
  },

  /**
   * @param {string} apiName
   * @returns {string=}
   *        The id of the View with the specified apiName.
   */
  apiNameToId: function(apiName:string) :string {
    var page = this.__state.apiNamesToViews[apiName];

    if (page) {
      return page.id;
    }
  },

  /**
   * @param {string} id
   * @returns {string=}
   *        The apiName of the View with the specified ID.
   */
  idToApiName: function(id:string) :string {
    var page = this.__state.views[id];

    if (page) {
      return page.apiName;
    }
  },

  /**
   * Get the number of pages known to the snippet
   * @return {number}
   */
  getNumberOfPages: function(): number {
    return _.keys(this.__state.views).length;
  },

  /**
   * Get all the views with a given activation type
   * @param {string} activationType
   * @returns {View[]}
   */
  getAllViewsForActivationType: function(activationType:string): View[] {
    return _.filter(this.__state.views, {
      activationType: activationType,
    });
  },

  /**
   * Loads view data into the store state
   * @param {Object} payload
   * @param {ClientData} payload.data
   * @private
   */
  __loadData: function(payload:any) {
    if (_.isEmpty(payload.data.views)) {
      return;
    }
    _.each(payload.data.views, _.bind(function(view) {
      freeze.deepFreeze(view);
      this.__state.views[view.id] = view;
      this.__state.apiNamesToViews[view.apiName] = view;
    }, this));
    this.emitChange();
  },
};
